'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSineGraph, iconSineGraphTag } from '@ni/nimble-components/dist/esm/icons/sine-graph';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSineGraph };
export { iconSineGraphTag };
export const NimbleIconSineGraph = wrap(IconSineGraph);